module.exports = __webpack_public_path__ + "static/media/eco-ecological-ecology-svgrepo-com.f7444cd7.svg";